import React, {Component} from 'react';

import AuthorityFacet from "../../../components/admin/authority/facet";

import AuthorityItem from "../../../components/admin/authority/item";
import ReactPaginate from "react-paginate";
import * as func from "../../../utils/functions";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import * as FActions from "../../../store/modules/footer";
import {objectToQueryString, pushUrl} from "../../../utils/functions";
import {BASE_PATH} from "../../../wpconfig";
import AuthorityPopup from "../../../components/admin/authority/popup"

class Authority extends Component {
	constructor(props) {
		super(props);

		let term_name = [];
		let term_status = [];
		let position_name = [];
		let ks = '';
		let record_id = '';
		let sub_ks = '';
		if (location.search.substring(1)) {
			let param = func.parseParams(location.search.substring(1));
			term_name = param.term_name ? param.term_name : [];
			term_status = param.term_status ? param.term_status : [];
			position_name = param.position_name ? param.position_name : [];
			ks = param.ks ? param.ks : '';
			record_id = param.record_id ? param.record_id : '';
			sub_ks = param.sub_ks ? param.sub_ks : '';
		}

		this.state = {
			isInit: false,
			param: {
				'ks' : ks,
				'record_id' : record_id,
				'sub_ks' : sub_ks,
				'date_type': 'input_date',
				'in_date_start' : '',
				'in_date_end' : '',
				'worker_id' : '',
				'term_name': term_name,
				'term_status': term_status,
				'position_name': position_name,
				'current_page' : 1,
			},
			records: [],
			totalRecords: 0,
			totalPage: 0,
			facet: {},
			category: [],
			categoryName: {},
			categoryType: 'position_type',
			insertRecord: null,
			editIndex: '',
			pkKey: 'authority_id',
			action: 'admin/authority_list',
			showSearchPopup : false,
			searchPopupIndex : '',
			searchPopupTitle : '',
			url: 'wp-admin/admin.php?page=researchmind-authority&',
		}

		this.onInsert = this.onInsert.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.onRemove = this.onRemove.bind(this);
		this.search = this.search.bind(this);
		this.showMessage = this.showMessage.bind(this);
		this.onEditIndex = this.onEditIndex.bind(this);
		this.setData = this.setData.bind(this);
		this.setSearchPopup = this.setSearchPopup.bind(this);
		this.set = this.set.bind(this);
	}

	componentDidMount() {
		this.getList();
	}

	getList() {
		func.getData(this.state.action, this.state.param).then((response) => {
			this.setState({
				records: response.records,
				facet: response.facet,
				totalRecords: response.pageInfo.totalResults,
				totalPage: response.pageInfo.totalPage,
			})

			if(this.state.param.record_id) {
				setTimeout(() => {
					if(response.records.length > 0) {
						if (response.records[0].authority_id === this.state.param.record_id)
							this.refs["ref" + response.records[0].authority_id].onEditSave()
					}
				}, 1000);
			}
		});

		func.getData("code/search/" + this.state.categoryType, {}).then((response) => {
			const t = {type: response.records[0].code_id};
			t.isInit = true
			t.category = response.records;
			t.categoryName = {}
			response.records.map((r, i) => {
				t.categoryName[r.code_id] = r.code_name;
			});
			this.setState(t);
		});
	}

	onInsert(event) {
		event.preventDefault();

		if (this.state.records.length > 0 && this.state.records[0][this.state.pkKey] === '') {
			this.showMessage('추가해주세요.')
		} else {
			const insertRecord = {
				scopus_id: "",
				position_name: "",
				memo: "",
				authority_id: '',
				term_parent: 0,
				kci_id: "",
				term_name : '',
				term_status: "publish",
				authority_term: "",
				authority_name: "",
				term_type: "heading",
				position_type: "",
				wos_id: "",
				mou: "",
				mou_code: "",
				mou_date: "",
				is_edit: true
			}
			this.onEditIndex(0);
			let records = this.state.records;
			records.unshift(insertRecord);
			this.setState({'records' : records})
		}
	}

	onEditIndex(id) {
		if (this.state.editIndex && this.refs["ref" + this.state.editIndex])
			this.refs["ref" + this.state.editIndex].onClose();
		else if (this.refs.ref)
			this.refs.ref.onClose();
		else if (this.refs["ref" + this.state.editIndex])
			this.refs["ref" + this.state.editIndex].onClose();
		this.setState({
			'editIndex': id
		})
	}

	onUpdate(index, record) {
		const records = [...this.state.records];
		records[index] = record;
		this.setState({records: records});
	}

	// onReload() {
	// 	func.getData("code/search/", this.props.param).then((response) => {
	// 		response.parentRecords = response.records;
	// 		delete response.records;
	// 		this.props.dataActions.setCode(response);
	// 	});
	// }

	onRemove(index) {
		const records = [...this.state.records];
		records.splice(index, 1);
		this.setState({records : records})
	}

	showMessage(message) {
		this.props.fDataActions.setFooter({
			'isNoticePopup': true,
			'noticeMessage': message
		})
		setTimeout(() => {
			this.props.fDataActions.setFooter({
				'isNoticePopup': false,
				'noticeMessage': ''
			})
		}, 3000);
	}

	setData(data) {
		this.setState(data)
		this.forceUpdate();
	}

	argsInputTextEvnet = (event) => {
		let param = this.state.param;
		param[event.target.name] = event.target.value;
		this.setData({"param": param});

		if (event.key === "Enter") {
			this.search()
		}
	}

	search = (event) => {
		if(event)
			event.preventDefault()

		func.getData(this.state.action, this.state.param).then((response) => {
			this.setState({
				isInit: true,
				records: response.records,
				facet: response.facet,
				totalRecords: response.pageInfo.totalResults,
				totalPage: response.pageInfo.totalPage,
			})

			const url = objectToQueryString(this.state.param);
			// wp-admin/admin.php?page=researchmind-authority&
			pushUrl('검색', BASE_PATH + this.state.url + url, this.state.param);
		});
	}

	setSearchPopup (status, searchPopupIndex, ks) {
		if(status) {
			this.setState({
				showSearchPopup : status,
				searchPopupIndex : searchPopupIndex,
				searchPopupTitle : ks ? ks : ''
			})
		} else {
			this.setState({
				showSearchPopup : status,
				searchPopupIndex : searchPopupIndex,
			})
		}
	}

	set (record) {
		let r = this.state.records[this.state.searchPopupIndex];
		r.term_parent = record.authority_id;
		r.set_authority_term = record.authority_term;
		let records = this.state.records;
		records[this.state.searchPopupIndex] = r;
		this.setState({records : records})
		setTimeout(() => {
			this.setSearchPopup(false, 0);
		}, 100);
	}

	handlePageClick = (page) => {
		const paged = page.selected + 1;

		let param = this.state.param;
		param.current_page = paged;

		func.getData(this.state.action, param).then((response) => {
			this.setState({
				isInit: true,
				records: response.records,
				facet: response.facet,
				totalRecords: response.pageInfo.totalResults,
				totalPage: response.pageInfo.totalPage,
			})

			const url = objectToQueryString(this.state.param);
			pushUrl('검색', BASE_PATH + this.state.url + url, this.state.param);
		});
	}

	render() {
		if(!this.state.isInit)
			return ''
		return (
			<div className="container-fluid mt-3 admin-layout">
				<div className="row">
					<div className="admin-sidebar">
						<AuthorityFacet
							param={this.state.param}
							setData={this.setData}
							facet={this.state.facet}
						/>
					</div>
					<div className="col admin-contents">

						<div className="d-flex justify-content-center mb-3">
							<div className="form-inline">
								<input type="text" className="form-control form-control-lg top-search mr-1" id="ks" name="ks"
									   defaultValue={this.state.param.ks} onKeyUp={this.argsInputTextEvnet} />
								<button type="button" className="btn btn-primary btn-top-search" onClick={this.search}>Search</button>
							</div>
						</div>
						<div className="d-flex mb-1">
							<div className="">
								<a href="#" onClick={this.deleteTrash} className="btn btn-outline-secondary btn-sm journal-trash-delete">휴지통 비우기</a>
							</div>
							<div className="ml-auto">
								<a href="#" onClick={this.onInsert} className="btn btn-success btn-sm">추가</a>
							</div>
						</div>

						<table className="table xtable-striped table-thin border-bottom authority-list">
							<thead>
							<tr>
								<th scope="col" className="mr-0"><input type="checkbox" className="ml-0 mr-0"/></th>
								<th scope="col">NO</th>
								<th scope="col">ID</th>
								<th scope="col">유형</th>
								<th scope="col">용어</th>
								<th scope="col">포지션</th>
								<th scope="col">상태</th>
								<th scope="col">입력일</th>
								<th scope="col">액션</th>
							</tr>
							</thead>
							<tbody>
							{this.state.records.map((record, index) => {
								return (
									<AuthorityItem
										key={record[this.state.pkKey]}
										index={record[this.state.pkKey]}
										ref={"ref" + record[this.state.pkKey]}
										pkKey={this.state.pkKey}
										arrIndex={index}
										categoryName={this.state.categoryName}
										record={record}
										category={this.state.category}
										mou={this.state.mou}
										onEditIndex={this.onEditIndex}
										onUpdate={this.onUpdate}
										onRemove={this.onRemove}
										showMessage={this.showMessage}
										setSearchPopup={this.setSearchPopup}
										showSearchPopup={this.state.showSearchPopup}
									/>
								)
							})}
							</tbody>
						</table>
						<div className="mt-4">
							<div>
								<div className="paging-wrap">
									<ReactPaginate
										forcePage={Number(this.state.param.current_page) - 1}
										pageCount={this.state.totalPage}
										marginPagesDisplayed={2}
										pageRangeDisplayed={2}
										onPageChange={this.handlePageClick}
										containerClassName={'pagination'}
										activeClassName={'active'}
										pageClassName={'page-item'}
										pageLinkClassName={'page-link'}
										previousClassName={'page-item page-item-prev'}
										previousLinkClassName={'page-link'}
										nextClassName={'page-item page-item-next'}
										nextLinkClassName={'page-link'}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>

				{this.state.showSearchPopup &&
					<AuthorityPopup
						showSearchPopup={this.state.showSearchPopup}
						setSearchPopup={this.setSearchPopup}
						set={this.set}
						category={this.state.category}
						showMessage={this.showMessage}
						ks={this.state.searchPopupTitle}
					/>
				}

			</div>
		)
	}
}


export default connect(
	(state) => ({
	}),
	(dispatch) => ({
		fDataActions: bindActionCreators(FActions, dispatch)
	}),
)(Authority)